import { type ReactNode } from "react";

import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { Link } from "@/libraries/design/components";
import { useLocalizedHref } from "@/libraries/web-framework/src/localization/use-localized-href";

export const TermsAndConditions = () => (
    <p css={termsAndConditionsCss} data-testid="terms-and-conditions">
        <FormattedMessage
            id="BxpUiSignup.SignupForm.termsAndConditions"
            defaultMessage="I agree to the <termsOfServiceLink>Atlassian Customer Agreement</termsOfServiceLink>, which incorporates by reference the <aiTermsLink>AI Product-Specific Terms</aiTermsLink>, and acknowledge the <privacyPolicyLink>Privacy Policy</privacyPolicyLink>."
            values={{
                termsOfServiceLink: TermsOfServiceLink,
                aiTermsLink: AiTermsLink,
                privacyPolicyLink: PrivacyPolicyLink
            }}
        />
    </p>
);

const AiTermsLink = (text: ReactNode) => {
    const aiTermsLinkHref = useLocalizedHref(
        "/legal/product-specific-terms#atlassian-intelligence-specific-terms"
    );
    return (
        <Link
            aria-label={text as unknown as string}
            href={aiTermsLinkHref}
            text={text as unknown as string}
            type="inline"
        />
    );
};

const PrivacyPolicyLink = (text: ReactNode) => {
    const privacyPolicyLinkHref = useLocalizedHref(
        "/legal/privacy-policy#what-this-policy-covers"
    );
    return (
        <Link
            aria-label={text as unknown as string}
            href={privacyPolicyLinkHref}
            text={text as unknown as string}
            type="inline"
        />
    );
};

const TermsOfServiceLink = (text: ReactNode) => {
    const termsOfServiceLinkHref = useLocalizedHref(
        "/legal/cloud-terms-of-service"
    );
    return (
        <Link
            aria-label={text as unknown as string}
            href={termsOfServiceLinkHref}
            text={text as unknown as string}
            type="inline"
        />
    );
};

const termsAndConditionsCss = css({
    fontSize: "0.875rem",
    lineHeight: "1.25rem",
    marginBlockEnd: "1rem",
    marginBlockStart: 0
});
